"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LicenseSuitableMode = void 0;
var LicenseSuitableMode;
(function (LicenseSuitableMode) {
    LicenseSuitableMode["NONE"] = "None";
    LicenseSuitableMode["PRO"] = "Pro";
    LicenseSuitableMode["EXPERT"] = "Expert";
})(LicenseSuitableMode || (exports.LicenseSuitableMode = LicenseSuitableMode = {}));
